export const SERVICE_TYPE_CHAT = 1
export const SERVICE_TYPE_CV_REVIEW = 2
export const SERVICE_TYPE_ITV = 3
export const SERVICE_TYPE_ITV_CV_REVIEW = 4
export const SERVICE_TYPE_CAREER_PLANNING = 5

export const CHAT_OPEN_AFTER_POST = 1
export const CHAT_OPEN_AFTER_ORDER = 2
export const CHAT_OPEN_ALWAYS = 3
export const CHAT_CLOSE = 4

export const CV_REVIEW_OPEN = 1
export const CV_REVIEW_CLOSE = 2

export const INTERVIEW_OPEN = 1
export const INTERVIEW_CLOSE = 2

export const ITV_CV_REVIEW_OPEN = 1
export const ITV_CV_REVIEW_CLOSE = 2

export const CAREER_PLANNING_OPEN = 1
export const CAREER_PLANNING_CLOSE = 2
